module.exports = __webpack_public_path__ + "static/content1-img-9b47bac29fbacd4034c0ea9810a5c3ca.png";